import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';
import {VehicleBrand} from '../../../../../domain/core/vehicle-brand.model';

@Component({
  selector: 'app-wizard-start-page',
  imports: [
    NgClass
  ],
  standalone: true,
  templateUrl: './wizard-start-page.component.html'
})
export class WizardStartPageComponent {
  @Input() brand: VehicleBrand;
  @Output() nextStep = new EventEmitter<void>();
}
